export const locale = {
  lang: 'en',
  data: {
    'My Profile': 'My Profile',
    'Logout': 'Logout'
  }
};
